import { provideState } from '@ngrx/store';
import { ConfigurationReducer } from './configuration.reducer';
import { RegistryResolver } from '../data/registry/registry-resolver/registry-resolver.service';
import { CustomerService } from './customer.service';

export const provideConfigurationFeature = () => [
    provideState('configuration', ConfigurationReducer),
    RegistryResolver,
    CustomerService,
];
